import React from 'react';
import { Box, Typography } from '@mui/material';

export default function SectionBlock({ title }) {
  return (
    <Box
      sx={{
        px: 2,
        py: 0.625,
        bgcolor: '#f8fafc',
        borderTop: '1px solid #e2e8f0',
        borderBottom: '1px solid #e2e8f0',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: '#475569',
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          fontSize: 10,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
